/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { StyledProgressBarContainer } from './progressBarStyles';
export var EmbersProgressBar = function EmbersProgressBar(_ref) {
  var _ref$steps = _ref.steps,
    steps = _ref$steps === void 0 ? 3 : _ref$steps,
    current = _ref.current,
    text = _ref.text,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    barColor = _ref.barColor;
  var stepArr = new Array(steps < 0 ? 0 : Math.floor(steps)).fill('');
  return /*#__PURE__*/React.createElement(StyledProgressBarContainer, {
    className: "EmbersProgressBar ".concat(className),
    "data-barcolor": barColor
  }, /*#__PURE__*/React.createElement("div", {
    className: "progress-text"
  }, text), /*#__PURE__*/React.createElement("div", {
    className: "progress-steps"
  }, stepArr.map(function (step, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "progress-step".concat(index < current ? ' active' : '')
    });
  })));
};